import React from 'react';
import Policy from '../';
import Styled from './style';

const Index = (props) => {
  return <Policy {...props} Styled={Styled} />;
};

export default Index;
